/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CellPhone from './cell-phone-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CellPhone {...validProps} color={validProps.color ? validProps.color : '#4D4540'} />;
}
SvgComponent.iconName = 'cellPhone';

export const CellPhoneIcon = svgIconWrapper(SvgComponent);
